<template>
  <v-dialog v-model="dialog" persistent max-width="35%">
    <v-card class="pb-2">
      <v-toolbar color="#313a46">
        <v-card-title class="text-h5 white--text"> Logs 
          <v-spacer></v-spacer>
          <v-btn icon @click="closeModal()">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </v-toolbar>
      <v-card-text>
        <BaseDataTable
          :headers="headers"
          :items="logs"
          @pageChange="fetchLogs({ page: $event })"
          :paginate="true"
          :currentPage="currentPage"
          :lastPage="lastPage"
          :items-per-page="5"
          :loading="loading"
          class="mt-4"
        >
          <template v-slot:[`item.created_at`]="{ item }">
            {{ item.created_at | BrazilianStandardDateAndTime }}
          </template>
        </BaseDataTable>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// import toast from "@/commom/toast";
import BaseDataTable from "@/components/BaseDataTable.vue";
import dateMixin from "@/mixins/dateMixin";
import BloqueioPrefeitura from "@/services/http/rpa/BloqueioPrefeitura.js";

export default {
  mixins: [dateMixin],

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    idPrefeitura: {
      type: String,
    },
  },

  components: {
    BaseDataTable,
  },

  data() {
    return {
      currentPage: 1,
      lastPage: 1,
      logs: [],
      loading: true,
      headers: [
        {
          text: "Usuário",
          value: "usuario",
          sortable: false,
          filterable: false,
        },
        {
          text: "Ação",
          value: "acao",
          sortable: false,
          filterable: false,
        },
        {
          text: "Data",
          value: "created_at",
          sortable: false,
          filterable: false,
        },
      ],
    };
  },

  watch: {
    idPrefeitura(value) {
      this.fetchLogs();
    },
  },

  methods: {
    async fetchLogs(filter = {}) {
      this.loading = true;
      try {
        let { data } = await BloqueioPrefeitura().logsShow({
          cod_ibge: this.idPrefeitura,
          ...filter,
        });
        this.logs = data.data;
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    formatText(text) {
      return text.replace(/-Ped.*/, "");
    },

    closeModal() {
      this.$emit("update:dialog", false);
    },
  },
};
</script>
<style>
.magin-text {
  margin: 100px 0;
}
</style>
